(function TV2dkHeader(window) {
  const header = window.document.querySelector('.tc_header');
  const headerHeight = header.offsetHeight;
  const initAnimationAfter = 500;
  const scrollTriggerDelta = 100;

  let scrolling;
  let ticking = false;
  let lastScroll = 0;

  // HEADER VISIBILITY
  const headerAnimate = () => {
    // scrolling down
    if (scrolling - scrollTriggerDelta > lastScroll) {
      if (headerHeight < scrolling) {
        header.classList.remove('tc_header--sticky-show');
      }

      if (headerHeight * 2 < scrolling) {
        header.classList.add('tc_header--sticky');
      }

      if (initAnimationAfter < scrolling) {
        // we need to make sure tc_header--sticky and the animate class
        // is not set in the same tick
        // if they are both added in the same tick, the animation transition will flash
        setTimeout(() => {
          header.classList.add('tc_header--sticky-animate');
        }, 0);
      }

      lastScroll = scrolling;

      // scrolling up
    } else if (
      scrolling + scrollTriggerDelta < lastScroll ||
      scrolling < headerHeight
    ) {
      if (!header.classList.contains('tc_header--sticky-animate')) {
        header.classList.remove('tc_header--sticky');
      }

      header.classList.add('tc_header--sticky-show');

      lastScroll = scrolling;
    }

    if (
      scrolling === 0 ||
      (header.getAttribute('data-variant') === 'feature' &&
        scrolling < headerHeight)
    ) {
      header.classList.remove('tc_header--sticky');
      header.classList.remove('tc_header--sticky-animate');
      header.classList.remove('tc_header--sticky-show');
    }

    ticking = false;
  };

  function headerRequestTick() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(headerAnimate);
    }
  }

  function headerOnScroll() {
    scrolling = window.pageYOffset;
    headerRequestTick();
  }

  window.addEventListener('scroll', headerOnScroll, false);

  // LOCAL HEADER NAVIGATION
  const headerLocal = header.querySelector('.tc_header__local');

  if (headerLocal && !headerLocal.classList.contains('js-processed')) {
    const headerLocalButtonPrev = headerLocal.querySelector(
      '.tc_header__local__button-prev',
    );
    const headerLocalButtonNext = headerLocal.querySelector(
      '.tc_header__local__button-next',
    );
    const headerLocalNav = headerLocal.querySelector('.tc_header__local__nav');

    const widthBuffer = 20;
    const scrollBuffer = 80;

    let resizeTimer = null;
    let windowWidth = window.innerWidth;
    let headerLocalWidth = headerLocal.offsetWidth;
    let headerLocalNavWidth = headerLocalNav.offsetWidth;

    // Handle scroll to current menu item
    const localNavAutoScroll = (headerLocalNavWidth) => {
      const headerLocalNavCurrentItem = headerLocalNav.querySelector(
        '[aria-current="true"]',
      );
      if (headerLocalNavCurrentItem) {
        const headerLocalNavCurrentItemRect =
          headerLocalNavCurrentItem.getBoundingClientRect();

        const scrollWidth =
          headerLocalNavCurrentItemRect.left +
          headerLocalNavCurrentItemRect.width / 2 -
          headerLocalNavWidth / 2;

        headerLocalNavCurrentItemRect.right > headerLocalNavWidth &&
          headerLocalNav.scrollBy(scrollWidth, 0);
      }
    };

    // Enable/disable arrow buttons
    const buttonVisibilityHandler = (container) => {
      let prevDisabled = container.scrollLeft < widthBuffer;
      let nextDisabled =
        container.scrollLeft >
        container.scrollWidth - container.clientWidth - widthBuffer;

      if (prevDisabled) {
        headerLocalButtonPrev.setAttribute('disabled', 'disabled');
      } else {
        headerLocalButtonPrev.removeAttribute('disabled');
      }

      if (nextDisabled) {
        headerLocalButtonNext.setAttribute('disabled', 'disabled');
      } else {
        headerLocalButtonNext.removeAttribute('disabled');
      }
    };

    // Setup button click listeners and scroll animation
    const buttonClickHandler = (scrollDistance) => {
      headerLocalButtonPrev.addEventListener('click', () => {
        headerLocalNav.scrollBy({
          left: -scrollDistance + scrollBuffer,
          behavior: 'smooth',
        });
      });
      headerLocalButtonNext.addEventListener('click', () => {
        headerLocalNav.scrollBy({
          left: scrollDistance - scrollBuffer,
          behavior: 'smooth',
        });
      });
      buttonVisibilityHandler(headerLocalNav);
    };

    // Window resize handling
    window.addEventListener('resize', () => {
      if (Math.abs(windowWidth - window.innerWidth) < 5) return;
      clearTimeout(resizeTimer);
      windowWidth = window.innerWidth;
      resizeTimer = setTimeout(function _resizeTimer() {
        headerLocalWidth = headerLocal.offsetWidth;
        buttonClickHandler(headerLocalWidth);
        headerLocalNavWidth = headerLocalNav.offsetWidth;
        localNavAutoScroll(headerLocalNavWidth);
      }, 300);
    });

    headerLocalNav.addEventListener('scroll', () =>
      buttonVisibilityHandler(headerLocalNav),
    );

    buttonClickHandler(headerLocalWidth);
    localNavAutoScroll(headerLocalNavWidth);
    headerLocal.classList.add('js-processed');
  }

  // MENU DIALOG
  const menuToggleButton = header.querySelector(
    '.tc_header__global__buttons__menu',
  );
  const menuDialog = header.querySelector(
    '.tc_header__global__buttons__dialog',
  );
  const menuDialogCloseButton = header.querySelector(
    '.tc_header__dialog__header__close',
  );
  const menuDialogCmpButton = header.querySelector('[data-cmp="cpc-open"]');

  // tracking
  const trackEvent = (event) => {
    try {
      window.tv2.analyticsUtils.trackEvent(event);
    } catch (_) {
      console.warn('unable to track event', { event });
    }
  };

  if (
    menuToggleButton &&
    !menuToggleButton.classList.contains('js-processed')
  ) {
    const openMenuDialog = () => {
      if (typeof HTMLDialogElement === 'function') {
        menuDialog.showModal();
      }

      // Handle scrollbars
      const scrollbarWidth =
        window.innerWidth - document.documentElement.clientWidth;
      scrollbarWidth > 0 &&
        (document.documentElement.style.marginRight = `${scrollbarWidth}px`);
      document.body.style.overflow = 'hidden'; // using js until Firefox supports :has

      // Timeout of '0' makes Safari animate dialog properly in :(
      setTimeout(() => {
        menuToggleButton.setAttribute('aria-expanded', 'true');
      }, 0);

      menuDialogCloseButton.addEventListener('click', closeMenuDialog);
      menuDialog.addEventListener('cancel', closeMenuDialogOnCancel);
      menuDialog.addEventListener('click', closeMenuDialogOnClickOutside);
      menuDialogCmpButton.addEventListener('click', closeMenuDialog);

      // Timeout removes unwanted focus-visible on 'close button' in desktop Safari :(
      setTimeout(() => {
        menuDialogCloseButton.blur();
      }, 100);

      animateAccordion();

      trackEvent('tv2dk.menu.open');
    };

    const closeMenuDialog = () => {
      menuToggleButton.setAttribute('aria-expanded', 'false');
      menuDialogCloseButton.removeEventListener('click', closeMenuDialog);
      menuDialog.removeEventListener('cancel', closeMenuDialogOnCancel);
      menuDialog.removeEventListener('click', closeMenuDialogOnClickOutside);
      menuDialogCmpButton.removeEventListener('click', closeMenuDialog);

      // Handle scrollbars
      document.documentElement.style.removeProperty('margin-right');
      document.body.style.removeProperty('overflow'); // using js until Firefox supports :has

      // Wait for CSS animation to end before closing dialog
      setTimeout(() => {
        menuDialog.close();
      }, 300);

      trackEvent('tv2dk.menu.close');
    };

    const closeMenuDialogOnCancel = (event) => {
      event.preventDefault();
      closeMenuDialog();
    };

    const closeMenuDialogOnClickOutside = (event) => {
      if (event.target === menuDialog) {
        closeMenuDialog();
      }
    };

    menuToggleButton.addEventListener('click', openMenuDialog);
    menuToggleButton.classList.add('js-processed');
  }

  // REELS AS OVERLAY
  const closeReelsAsOverlay = (event) => {
    closeOverlayButton.removeEventListener('click', closeReelsAsOverlay);
    window.history.back();
  };

  const closeOverlayButton = header.querySelector(
    '.tc_header__global__buttons__overlay-close',
  );

  if (
    closeOverlayButton &&
    !closeOverlayButton.classList.contains('js-processed')
  ) {
    closeOverlayButton.addEventListener('click', closeReelsAsOverlay);
    closeOverlayButton.classList.add('js-processed');
  }

  // ACCORDION ANIMATION
  const animateAccordion = () => {
    const menuDetailsWrapper = header.querySelector(
      '.tc_header__dialog__main__nav',
    );
    const menuDetailsList = menuDetailsWrapper.querySelectorAll('details');

    if (!menuDetailsWrapper.classList.contains('js-processed')) {
      menuDetailsList.forEach((details) => {
        const summary = details.querySelector('summary');
        const link = summary.querySelector('a');

        details.style.maxHeight = `${details.offsetHeight}px`;

        summary.addEventListener('click', (e) => {
          e.target === summary && e.preventDefault();
          const summaryHeight = summary.offsetHeight;

          if (e.target !== link) {
            if (details.hasAttribute('open')) {
              details.style.maxHeight = `${summaryHeight}px`;
              setTimeout(() => details.removeAttribute('open'), 300);
            } else {
              details.setAttribute('open', 'open');
              const ulHeight = details.querySelector('ul').offsetHeight;
              detailsHeight = `${summaryHeight + ulHeight}px`;
              details.style.maxHeight = detailsHeight;
            }
          }
        });
      });
      menuDetailsWrapper.classList.add('js-processed');
    }
  };
})(window);
